import {WlBrandedButton} from "../../../common/ts/webcomponents/brandedButton/button.component";
import {WlModal} from "../../../common/ts/webcomponents/modal/modal.component";
import {MiniSerpUnitContactModal} from "./MiniSerpUnitContactModal";
import PageData from "../../../common/ts/PageData";
import {ApplyOperationType} from "../../../common/ts/services/AdFormService";
import {MiniSerpPagination} from "./MiniSerpPagination";

export class MiniSerpUnits {
    static readonly MINI_SERP_CONTAINER_SELECTOR = '.js-mini-serp-container';
    static readonly MINI_SERP_UNITS_CONTAINER_SELECTOR = '.js-mini-serp-units-container';
    static readonly SALE_UNITS_CONTAINER_CLASS = 'mini-serp__units-for-sale';
    static readonly RENT_UNITS_CONTAINER_CLASS = 'mini-serp__units-for-rent';

    private readonly miniSerpUnitsContainer: HTMLElement;
    private readonly miniSerpContainer: HTMLElement;
    // TODO Pending refactor on ProjectPage to use a specific ProjectPageData instead of PageData
    private readonly pageData: PageData;

    constructor(params: {
        miniSerpUnitsContainer: HTMLElement,
        pageData: PageData
    }) {
        this.miniSerpUnitsContainer = params.miniSerpUnitsContainer;
        this.pageData = params.pageData;

        this.miniSerpContainer = document.querySelector<HTMLElement>(MiniSerpUnits.MINI_SERP_CONTAINER_SELECTOR) as HTMLElement;
    }

    init() {
        if (!this.miniSerpUnitsContainer) {
            return;
        }
        this.bindAllContactButtonsToApplyModal();
        new MiniSerpPagination({
            miniSerpUnitsContainer: this.miniSerpUnitsContainer,
            onUnitsRefreshed: () => this.bindAllContactButtonsToApplyModal()
        }).init();
    }

    private bindAllContactButtonsToApplyModal() {
        const operationType = this.getOperationType();
        const modal: WlModal | null = document.querySelector<WlModal>(`#contact-modal-${operationType}`);
        if (!modal) {
            console.warn("No contact modal found for operation type:", operationType);
            return;
        }
        const miniSerpUnitContactModal = new MiniSerpUnitContactModal({
            modal,
            pageData: this.pageData,
            operationType: operationType
        });
        miniSerpUnitContactModal.init()

        document.querySelectorAll<WlBrandedButton>(`.js-contact-cta.${operationType.toLowerCase()}`).forEach(contactButton => {
            contactButton?.addEventListener(contactButton.clickEvent, (clickEvent) => {
                miniSerpUnitContactModal.openForUnitId(contactButton.id)
                clickEvent.stopImmediatePropagation()
            })
        })
    }

    private getOperationType(): ApplyOperationType {
        if (this.miniSerpUnitsContainer?.classList.contains(MiniSerpUnits.SALE_UNITS_CONTAINER_CLASS)) {
            return ApplyOperationType.SALE;
        }

        if (this.miniSerpUnitsContainer?.classList.contains(MiniSerpUnits.RENT_UNITS_CONTAINER_CLASS)) {
            return ApplyOperationType.RENT;
        }

        return ApplyOperationType.SALE;
    }
}
